import { Component, computed, inject, input } from '@angular/core';
import { FilterInput } from '@it2go/data-grid';
import { Operator } from '../../../../../../../../../data-grid/src/grid/grid-request.dto';
import { TableComponent } from '../../../../../shared/components/kit/table/table.component';
import { clientChipField, serviceField } from '../../../../../shared/components/kit/table/table.fields';
import {
    TableColumn,
    TableColumnAlignment,
    TableColumnType,
} from '../../../../../shared/components/kit/table/table.types';
import { ClientsWithoutRecentWorkWidgetStore } from './clients-without-recent-work-widget.store';
import { clientsWithoutRecentWorkFrag } from './clients-without-recent-work-widget.query';
import { PrimeTemplate } from '@openng/optimus-ui/api';
import { LocalDatePipe } from '../../../../../shared/pipes/local-date.pipe';
import { TranslatePipe } from '@ngx-translate/core';
import { UserWidgetSetting } from '@libs/types/src/services/types/service-settings-user-widgets.type';

@Component({
    selector: 'app-clients-without-recent-work-widget',
    templateUrl: './clients-without-recent-work-widget.component.html',
    providers: [ClientsWithoutRecentWorkWidgetStore],
    imports: [
        TableComponent,
        PrimeTemplate,
        LocalDatePipe,
        TranslatePipe,
    ],
})
export class ClientsWithoutRecentWorkWidgetComponent {
    protected readonly store = inject(ClientsWithoutRecentWorkWidgetStore);
    protected readonly prefix = 'dashboard.clientsWithoutRecentWork.';

    items = input<{ serviceId: string, widget: UserWidgetSetting }[]>([]);

    protected readonly additionalFilter = computed<FilterInput[][]>(() => [[{
        column: 'serviceId',
        operator: Operator.IN,
        value: this.items().map(item => item.serviceId),
    }]]);

    protected readonly columns = computed<TableColumn[]>(() => {
        const showServiceInfo = [...new Set(this.items().map(x => x.serviceId))].length > 1;

        let cols = [
            clientChipField('client', 'person', false),
            {
                name: 'age',
                type: TableColumnType.Age,
                dataKey: 'person.birthdate',
                alignment: TableColumnAlignment.Center,
                sortable: false,
                filterable: false,
            },
            {
                name: 'lastWorkAt',
                sortable: false,
                filterable: false,
            },
        ];

        if (showServiceInfo) {
            cols = [
                ...cols.slice(0, 1),
                serviceField('service', 'serviceId'),
                ...cols.slice(1),
            ];
        }

        return cols;
    });

    protected readonly fragment = clientsWithoutRecentWorkFrag;
}
